<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div>
          <div class="title">AstrBot 后台</div>
          <div class="muted">{{ baseUrl }}</div>
        </div>
        <div class="toolbar-actions">
          <el-button icon="el-icon-refresh" @click="reloadFrame">刷新</el-button>
          <el-button type="primary" icon="el-icon-top-right" @click="openExternal">新窗口打开</el-button>
        </div>
      </div>
      <iframe class="astrbot-frame" :src="url" referrerpolicy="no-referrer"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "appAstrbot",
  data() {
    return {
      baseUrl: "https://astrbot.tianxuanji.com/",
      reloadKey: Date.now(),
    };
  },
  computed: {
    url() {
      return `${this.baseUrl}?_tx=${this.reloadKey}`;
    },
  },
  methods: {
    reloadFrame() {
      this.reloadKey = Date.now();
    },
    openExternal() {
      window.open(this.baseUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 18px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 12px;
}
.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.title {
  color: #1f2d3d;
  font-size: 22px;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 13px;
  margin-top: 6px;
}
.astrbot-frame {
  width: 100%;
  flex: 1;
  min-height: 0;
  border: 1px solid #dfe6ef;
  background: #fff;
}
</style>
